module.exports = __webpack_public_path__ + "static/media/Goals.c7526248.png";